import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import CountryContent from './CountryContent'
export default class Country extends Component {
    render() {
        let id = this.props.match.params.id;

        const urlParams = new URLSearchParams(window.location.search);
        return (
            
            <div className="wrapper">

                <div className="preloader hide flex-column justify-content-center align-items-center">
                    <img className="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
                </div>
                <Navbar />
                <Mainmenu />
                <CountryContent id={id} urlParams={urlParams} />
                <Footer />

            </div>


        )
    }
}
